var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Loading_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.379 14.31a1.8 1.8 0 0 1 3.524.735A14.47 14.47 0 0 0 3.6 18c0 7.953 6.447 14.4 14.4 14.4S32.4 25.953 32.4 18 25.953 3.6 18 3.6A1.8 1.8 0 0 1 18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18c0-1.25.128-2.485.379-3.69Z",
    fill: "#464958"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Loading_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-32-32H68V68H-32V-32Z",
    fill: "#F58025"
  }))));
};

export default SvgLoading;